import { render, staticRenderFns } from "./technocracy.vue?vue&type=template&id=535cc9e2"
import script from "./technocracy.vue?vue&type=script&lang=js"
export * from "./technocracy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('535cc9e2')) {
      api.createRecord('535cc9e2', component.options)
    } else {
      api.reload('535cc9e2', component.options)
    }
    module.hot.accept("./technocracy.vue?vue&type=template&id=535cc9e2", function () {
      api.rerender('535cc9e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/object/technocracy.vue"
export default component.exports